"use strict";

$ = jQuery;

validatorConfig();

function form(offerID, context) {

  return new Promise(function (resolve, reject) {
    formFirstStep(offerID, context).then(function (leadID) {
      return formSecondStep(offerID, leadID, context);
    }).then(function (leadID) {
      return resolve(leadID);
    });
  });
}